var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-popover',{attrs:{"placement":"top","width":"300","trigger":"hover"}},[_vm._l((_vm.infos),function(info){return _c('div',[_c('small',[_vm._v(_vm._s(info))])])}),_c('i',{staticClass:"el-icon-warning-outline mr-1",attrs:{"slot":"reference"},slot:"reference"})],2),_vm._v(" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }